import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryUpdateAction from './materialDeliveryUpdate.action.json' with { type: 'json' }
import { materialDeliveryItemObject, materialDeliveryObject } from '../materialDeliveryObject'

const materialDeliveryUpdateDefinition = defineAction({
  ...materialDeliveryUpdateAction,
  input: materialDeliveryObject
    .pick({
      id: true,
      deliveryDate: true,
    })
    .partial({ deliveryDate: true })
    .extend({
      items: z
        .array(
          materialDeliveryItemObject
            .pick({
              id: true,
              materialRequestItemId: true,
              materialId: true,
              deliveredQuantity: true,
            })
            .partial({
              id: true,
              materialRequestItemId: true,
              materialId: true,
            }),
        )
        .nullish(),
    }),
  output: z.object({}),
})

export default materialDeliveryUpdateDefinition
